import { ApiEndpointClient } from './resource-client';
const VALUATION_API_PREFIX = 'valuation-api/v1';
export class ValueChecksClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, VALUATION_API_PREFIX);
        this.http = http;
    }
    getValueCheck = async ({ valueCheckId, customerId }) => {
        return this.get(`/value-checks/${valueCheckId}`, customerId ? { query: { customer_uuid: customerId } } : undefined);
    };
    getValueChecks = async ({ assetId, customerId, baseValuationId }, options) => {
        const query = {};
        if (assetId)
            query.asset_uuid = assetId;
        if (customerId)
            query.customer_uuid = customerId;
        if (baseValuationId)
            query.base_valuation_uuid = baseValuationId;
        return this.get('/value-checks/', { ...options, query });
    };
    createValueCheck = async ({ baseValuationId }) => {
        return this.post('/value-checks/', { query: { base_valuation_uuid: baseValuationId } });
    };
    putValueCheck = async ({ valueCheckId, valueCheck, }) => {
        return this.put(`/value-checks/${valueCheckId}`, { json: valueCheck });
    };
    patchValueCheck = async ({ valueCheckId, operations, }) => {
        await this.patch(`/value-checks/${valueCheckId}`, { json: operations, response: 'raw' });
    };
    deleteValueCheck = async ({ valueCheckId }) => {
        await this.delete(`/value-checks/${valueCheckId}`, { response: 'raw' });
    };
    uploadValueCheckReportFile = async ({ valueCheckId, file }) => {
        return this.postFile(`/value-checks/${valueCheckId}/report-file`, file);
    };
    uploadValueCheckReportXls = async ({ valueCheckId, file }) => {
        return this.postFile(`/value-checks/${valueCheckId}/report-xls`, file);
    };
}
